import { buildUrlUpdateScenarioApi } from 'routes/api';
import { NoScenario, TypeScenarioNameRequestAPI } from 'types/scenario';
import { useWriter } from '../useWriter';
import useData from '../useData';

export const useUpdateScenarioNameAPI = (scenarioId?: number) => {
    const { currentScenario, currentCountry, currentUnit, currentUnitType } = useData();

    const { writeData, ...response } = useWriter<TypeScenarioNameRequestAPI, null>({
        url: buildUrlUpdateScenarioApi(scenarioId ?? currentScenario?.id ?? NoScenario, currentCountry ?? '', currentUnit ?? '', currentUnitType ?? ''),
    });

    return {
        ...response,
        updateScenarioName: writeData
    };
};
